import { render } from "./ProjectDropdown.vue?vue&type=template&id=4874bd91&scoped=true&ts=true&lang=pug"
import script from "./ProjectDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDropdown.vue?vue&type=style&index=0&id=4874bd91&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4874bd91"]])

export default __exports__